import React from "react";
import { Box, Button, Stack } from "@mui/material";
import Search from "./Search";
import Logo from "../../../../components/common/layout/header/Logo";

interface IHeader {
  height: string;
}

function Header({ height }: IHeader) {
  return (
    <Box
      sx={{
        position: "sticky",
        height,
        px: 2,
        backgroundColor: "background.paper",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100%" }}
      >
        <Stack direction="row" alignItems="center" gap={2} sx={{ flex: 1 }}>
          <Logo />
          <Search condition={{}} setCondition={() => {}} />
        </Stack>
        <Button
          variant="contained"
          sx={{
            boxShadow: "none",
            textTransform: "none",
            backgroundColor: "divider",
            "&:hover": { boxShadow: "none", backgroundColor: "divider" },
          }}
        >
          Đại lý lắc chuông
        </Button>
      </Stack>
    </Box>
  );
}

export default Header;
